var GMap, GMapDesktop2016V2Markers, GMapDesktop2016V2View, OldGMapView, _highlightMerchantLocationCard, _highlightMerchantPin,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GMap = window.GMap != null ? window.GMap : window.GMap = {};

if (GMap.vent == null) {
  GMap.vent = require('../../../frontend/helpers/events');
}

GMapDesktop2016V2Markers = require('../markers');

OldGMapView = require('../../../frontend/views/g_map');

module.exports = GMapDesktop2016V2View = (function(superClass) {
  extend(GMapDesktop2016V2View, superClass);

  function GMapDesktop2016V2View() {
    return GMapDesktop2016V2View.__super__.constructor.apply(this, arguments);
  }

  GMapDesktop2016V2View.prototype.events = {
    'mouseover .is-maps-v2': 'changeToDynamic'
  };

  GMapDesktop2016V2View.prototype.initialize = function() {
    GMapDesktop2016V2View.__super__.initialize.apply(this, arguments);
    this.Markers = GMapDesktop2016V2Markers;
    this.assignCardOrder();
    GMap.vent.on('clickedMerchantPin', (function(_this) {
      return function() {
        var index;
        index = arguments[0].index;
        return _this._handleMarkerClick(index);
      };
    })(this));
    return GMap.vent.on('mouseOverMerchantPin', (function(_this) {
      return function(arg) {
        var index;
        index = arg.index;
        index = Math.floor(index / 2);
        return _this.highlightSelectedMerchant({
          index: index,
          skipCentering: true
        });
      };
    })(this));
  };

  GMapDesktop2016V2View.prototype.start = function() {
    GMapDesktop2016V2View.__super__.start.apply(this, arguments);
    this.markerHandler.adjustMarkersPosition(this.activeMap, this.userMarkerData);
    this.markerHandler.addUserMarker(this.activeMap, this.userMarkerData);
    return this.googleMaps.event.addListenerOnce(this.activeMap, 'bounds_changed', (function(_this) {
      return function() {
        return _this.$el.find('.dynamic-map .merchant-location-card:not(".all-locations")').on('mouseover', function(event) {
          var card;
          if (_this.$el.attr('id') === 'merchant-info-map') {
            card = $(event.currentTarget);
            return _this.highlightSelectedMerchant({
              index: card.index()
            });
          }
        });
      };
    })(this));
  };

  GMapDesktop2016V2View.prototype.assignCardOrder = function() {
    var listLength;
    listLength = this.$locationsModal.find('.address-card').length;
    return this.$locationsModal.find('.merchant-location-card').css('z-index', function(i) {
      return listLength - i;
    });
  };

  GMapDesktop2016V2View.prototype.changeToDynamic = function(event) {
    if ((event != null ? event.type : void 0) === 'mouseover') {
      this.$el.off('mouseover', '.is-maps-v2');
    }
    return GMapDesktop2016V2View.__super__.changeToDynamic.apply(this, arguments);
  };

  GMapDesktop2016V2View.prototype.highlightSelectedMerchant = function(options) {
    var index, skipCentering;
    if (options == null) {
      options = {};
    }
    index = options.index, skipCentering = options.skipCentering;
    if (index !== this.previousIndex) {
      _highlightMerchantPin.call(this, index);
      _highlightMerchantLocationCard.call(this, index);
      if (skipCentering == null) {
        this.reCenterMap(index);
      }
    }
    return this.previousIndex = index;
  };

  GMapDesktop2016V2View.prototype.showMerchantLocationsModal = function() {
    if (this.$el.find('.all-locations').length) {
      return GIG.Modal.open({
        id: 'locations'
      });
    }
  };

  GMapDesktop2016V2View.prototype.reCenterMap = function(index) {
    var activeMarkers, realIndex, ref, ref1;
    if (!((this.activeMap != null) && this.centeredMarkerIndex !== index)) {
      return;
    }
    activeMarkers = this.markerHandler.activeMarkers;
    realIndex = this.markerHandler.getRealIndex(index);
    this.activeMap.panTo({
      lat: (ref = activeMarkers[realIndex]) != null ? ref.position.lat() : void 0,
      lng: (ref1 = activeMarkers[realIndex]) != null ? ref1.position.lng() : void 0
    });
    this.activeMap.panBy(-162, 0);
    return this.centeredMarkerIndex = index;
  };

  GMapDesktop2016V2View.prototype._handleMarkerClick = function(index) {
    if (!this.shouldShowLocationsModal()) {
      index = Math.floor(index / 2);
      return this.reCenterMap(index);
    }
  };

  return GMapDesktop2016V2View;

})(OldGMapView);

_highlightMerchantLocationCard = function(index) {
  this.$el.find('.selected-location').removeClass('selected-location');
  return this.$el.find('.merchant-location-card:eq(' + index + ')').find('.address-top').addClass('selected-location');
};

_highlightMerchantPin = function(index) {
  if (this.markerHandler != null) {
    this.markerHandler.updateIcon(index, "SELECTED");
    return this.markerHandler.updateIcon(this.previousIndex, "DEFAULT");
  }
};

//# sourceMappingURL=data:application/json;base64,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
